import { Router, ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";
import {
  ViewEncapsulation,
  HostListener,
  ElementRef,
  Component,
  ViewChild,
  OnInit,
} from "@angular/core";

// Environments
import { environment } from "src/environments/environment";

// Libraries
import * as _ from "underscore";

// Services
import { PromotionsService } from "src/app/modules/promotions/services/promotions.service";
import { TranslationService } from "src/app/modules/shared/services/translation.service";
import { EmitterService } from "src/app/modules/shared/services/emitter.service";
import { CommonService } from "src/app/modules/shared/services/common.service";
import { MainService } from "src/app/modules/shared/services/main.service";
import { UtilityService } from "src/app/utility/utility.service";

@Component({
  selector: "app-all-promotions",
  templateUrl: "./all-promotions.component.html",
  styleUrls: ["./all-promotions.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class AllPromotionsComponent implements OnInit {
  @ViewChild("pageHeader", { static: false }) pageHeader: ElementRef;
  @ViewChild("popupOver", { static: false }) popupOver: ElementRef;
  langCode: string;
  langCodeSubscription: Subscription;
  logOutCompleteBsSubscription: Subscription;
  loginCompleteBsSubscription: Subscription;
  promotions;
  isLoading: boolean;
  promotionSnippetSubscription: Subscription;
  isLoggedIn: boolean;
  reloadBannersSub: any;
  pageHeaderBg: boolean = false;

  @HostListener("window:scroll") onScroll() {
    this.pageHeaderBg = this.utility.scrollAddClass();
  }
  constructor(
    private router: Router,
    private utility: UtilityService,
    private activatedRoute: ActivatedRoute,
    public translationService: TranslationService,
    private promotionsService: PromotionsService,
    private commonService: CommonService,
    private mainService: MainService,
    private emitterService: EmitterService
  ) {
    this.langCode = this.utility.getLangCode();
    this.langCodeSubscription = this.translationService.langCode$.subscribe(
      (langCode) => {
        this.langCode = langCode;
        this.updateSEOContent();
        if (this.langCode) {
          this.allPromotionCards(true);
        }
      }
    );
    /**allpromotionCards call is not required bacause on logout , because
     * we navigate user back to home page
     * */
    this.loginCompleteBsSubscription = this.commonService.loginComplete.subscribe(
      (isloggedIn) => {
        this.isLoggedIn = true;
        this.allPromotionCards(true);
      }
    );
    this.logOutCompleteBsSubscription = this.commonService.logOutComplete.subscribe(
      (isloggedOut) => {
        this.isLoggedIn = false;
        this.allPromotionCards(true);
      }
    );
    this.reloadBannersSub = this.emitterService.depositSuccessful$.subscribe(
      (flag) => {
        this.allPromotionCards(true);
      }
    );
  }

  ngOnInit() {
    window["prerenderReady"] = false;
    this.updateSEOContent();
    this.activatedRoute.params.subscribe((params) => {
      this.allPromotionCards();
    });
  }

  updateSEOContent() {
    this.utility.setSEO({
      metaDescription: this.translationService.instant(
        "SEO.promotions_metaDescription"
      ),
      metaTags: this.translationService.instant("SEO.promotions_metaTag"),
      metaTitle: this.translationService.instant("SEO.promotions_metaTitle"),
      title: this.translationService.instant("SEO.promotions_title"),
    });
    this.commonService.setCanonicalURL("promotionspage");
  }

  allPromotionCards(isForce?) {
    this.isLoading = true;
    const { replaceAll } = this.utility;
    Promise.resolve(this.promotionsService.getAllPromotionsp(isForce)).then(
      (promoData) => {
        this.isLoading = false;
        if (promoData && promoData.length > 0) {
          this.promotions = promoData;
          _.each(this.promotions, function (promoData) {
            promoData.snippet = replaceAll(promoData.snippet, {
              "{{site_url}}": environment.siteUrl,
              "{{media_url}}": environment.mediaUrl,
            });
          });
        } else {
          this.promotions = [];
        }
        if (this.isLoggedIn) {
          this.checkNavigateData();
        }
        window["prerenderReady"] = true;
      }
    );
  }

  checkNavigateData() {
    const navigateData = this.commonService.getNavigateAfterLogin();
    if (
      this.promotions &&
      this.promotions.length > 0 &&
      navigateData &&
      navigateData["data"]
    ) {
      let filterdData = _.filter(this.promotions, (promotion) => {
        let promotionUrl;
        /**need to remove this replace function after CMS change(Their an issues from CMS),It's a hack */
        if (
          this.translationService.instant("url.promotions") !== "promotions"
        ) {
          promotionUrl = promotion["url"];
          promotionUrl = promotionUrl.replace("promotions", "");
        } else {
          promotionUrl = promotion["url"];
        }
        return navigateData["data"]["path"].endsWith(promotionUrl);
      });
      if (filterdData.length > 0) {
        this.router.navigate([navigateData["data"]["path"]]);
      }
    }
  }

  gotoPromotionPage(url) {
    this.utility.closeAccountComponent("");
    if (url && url.length > 0) {
      /**need to remove this replace function after CMS change,It's a hack */
      if (this.translationService.instant("url.promotions") !== "promotions") {
        url = url.replace("promotions", "");
      }
      this.router.navigate([this.langCode + "/" + url]);
    }
  }

  backToHome() {
    this.utility.closeAccountComponent("");
    this.router.navigate([this.langCode + "/casino"]);
  }

  ngOnDestroy() {
    if (this.commonService.getNavigateAfterLogin()) {
      this.commonService.setNavigateAfterLogin(undefined);
    }
    this.utility.removeClassFromAppBody("overflow-hidden");
    this.loginCompleteBsSubscription.unsubscribe();
    if (this.promotionSnippetSubscription) {
      this.promotionSnippetSubscription.unsubscribe();
    }
    if (this.langCodeSubscription) {
      this.langCodeSubscription.unsubscribe();
    }
  }
}
